import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';

import PulseRouter from './components/PulseRouter.js';

import './index.css';


ReactDOM.render(
  <PulseRouter history={browserHistory} />,
  document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js